import React, { Component } from 'react'
import PropTypes from 'prop-types'
import actions from 'redux/actions'
import { connect } from 'redaction'
import moment from 'moment'
import { formatPrice, constants, compose, sentry } from 'common/helpers'
import { FormattedHTMLMessage, injectIntl } from 'sb-react-intl'

import { ButtonsInRow, Button, buttonMessages } from 'components/_new/controls'
import { ContentLoader } from 'components/_new/ui'
import Bill from 'components/payment/Bill/Bill'

import Title from '../Title/Title'

import messages from './messages'
import s from './SelectedPlanSummary.scss'


class SelectedPlanSummary extends Component {

  static propTypes = {
    isFetching: PropTypes.bool,
    placement: PropTypes.string,
    intl: PropTypes.object,
    selectedPlan: PropTypes.object,
    onClose: PropTypes.func,
    goToStep: PropTypes.func,
    onSuccess: PropTypes.func,
    hideLoader: PropTypes.func,
    showLoader: PropTypes.func,
    // costs: PropTypes.shape({
    //   balance: PropTypes.number,
    //   tax: PropTypes.number,
    //   inquirePlan: PropTypes.object,
    // }),
    // upgradeActivationMonth: PropTypes.string,
  }

  static defaultProps = {
    isFetching: false,
    showLoader: () => {},
    hideLoader: () => {},
    selectedPlan: {},
  }

  state = {
    isFetching: true,
    costs: null,
    upgradeActivationMonth: null,
  }

  componentDidMount() {
    const { hideLoader, showLoader, selectedPlan, selectedPlan: { name } } = this.props

    if (!Boolean(name)) {
      console.error('SelectedPlanSummary without selectedPlan')
      sentry.captureException('SelectedPlanSummary without selectedPlan', {
        selectedPlan,
      })
      this.goPrevStep()
    }
    else {
      showLoader()

      actions.models.subscription.fetchPlanCosts(name)
        .then((result) => {
          const { upgradeActivationDate } = result

          const state = {
            isFetching: false,
            costs: result,
          }

          if (upgradeActivationDate) {
            state.upgradeActivationMonth = moment(upgradeActivationDate).format('MMMM')
          }

          hideLoader()
          this.setState(state)
        })
        .catch((err) => {
          console.error(err)
          hideLoader()
          this.goPrevStep()
        })
    }
  }

  goPrevStep = () => {
    const { goToStep } = this.props

    goToStep(constants.upgradeSubscriptionFlowSteps.selectPlan)
  }

  goNextStep = () => {
    const {
      showLoader, hideLoader, selectedPlan: { name },
      goToStep, placement, onSuccess, onClose,
    } = this.props

    showLoader()

    actions.models.subscription.changePlan(name, placement)
      .finally(() => hideLoader())
      .then(
        () => {
          if (typeof onSuccess === 'function') {
            onSuccess()
          }
          else {
            goToStep(constants.upgradeSubscriptionFlowSteps.upgradeSuccess)
          }
        },
        (err) => {
          console.error(err)
          if (typeof onClose === 'function') {
            onClose()
          }
        }
      )
  }

  getSummaryItems = () => {
    const { intl, selectedPlan } = this.props
    const { costs: { balance, tax, inquirePlan = {} } } = this.state
    const { scentCount /* deprecated */, productsPerPeriod, monthCount /* deprecated */, billingPeriod } = selectedPlan

    const { totalPrice } = inquirePlan

    return [
      {
        label: {
          ...messages.planName,
          values: {
            scentCount: scentCount || productsPerPeriod,
            monthCount: monthCount || billingPeriod,
          },
        },
        value: formatPrice(totalPrice, true),
      },
      {
        label: messages.currBalance,
        value: formatPrice(-balance, true),
        tooltip: messages.balanceTooltipText,
      },
      {
        label: messages.tax,
        value: formatPrice(tax, true),
      },
      {
        label: messages.shipping,
        value: intl.formatMessage(messages.free),
      },
    ]
  }

  handleBackClick = () => {
    const { onClose, isCloseOnBackClick } = this.props

    if (isCloseOnBackClick && typeof onClose === 'function') {
      onClose()
    }
    else {
      this.goPrevStep()
    }
  }

  render() {
    const { isFetching: isPropsFetching } = this.props
    const { isFetching } = this.state

    if (isPropsFetching || isFetching) {
      return <ContentLoader />
    }

    // ATTN use "price" instead of "priceWithCredits" in Recurly! Remove "priceWithCredits" in future
    const {
      costs: { price: totalPrice, priceWithCredits },
      upgradeActivationMonth,
    } = this.state

    const summaryItems = this.getSummaryItems()
    const isChargeInfoVisible = upgradeActivationMonth

    return (
      <div className={s.selectedPlanSummary}>
        <Title message={messages.title} />
        <Bill
          items={summaryItems}
          total={priceWithCredits || totalPrice}
        />
        {
          isChargeInfoVisible && (
            <div className={s.note}>
              {
                Boolean(upgradeActivationMonth) && (
                  <FormattedHTMLMessage tag="p" values={{ upgradeActivationMonth }} {...messages.estimateNote} />
                )
              }
            </div>
          )
        }
        <ButtonsInRow className={s.buttons}>
          <Button
            className={s.button}
            title={buttonMessages.back}
            color="white"
            size="md"
            dataTestId="backButton"
            onClick={this.handleBackClick}
          />
          <Button
            className={s.button}
            title={buttonMessages.confirm}
            color="brand"
            size="md"
            dataTestId={constants.testIds.upgrade.confirmButton}
            onClick={this.goNextStep}
          />
        </ButtonsInRow>
        <FormattedHTMLMessage className={s.attention} tag="div" {...messages.attention} />
      </div>
    )
  }
}


export default compose(
  connect((state) => {
    return {
      selectedPlan: actions.models.upgradeSubscriptionFlow.getSelectedPlan(state) || {},
    }
  }),
  injectIntl
)(SelectedPlanSummary)
